import {Component, Input, NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-ticker-card',
  templateUrl: './ticker-card.component.html',
  styleUrls: ['./ticker-card.component.scss']
})
export class TickerCardComponent{
  @Input() titleText: string = "";

  @Input() total: string | null = null;

  @Input() percentage: number = 0;

  @Input() icon: string = "";

  @Input() tone?: 'info' | 'positive' | 'warning' | 'negative';

  @Input() contentClass: string | null = null;

  abs(value: number): number {
    return Math.abs(value);
  }

  getIconClass = () => this.tone || (this.percentage > 0 ? 'positive' : 'negative');
}

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [TickerCardComponent],
  exports: [TickerCardComponent],
})
export class TickerCardModule { }
